import isEmpty from 'lodash/isEmpty'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRequestTable from 'app/hooks/useRequestTable'
import requests, {
    LaneFeeAwardRejectFilterRequestResponse,
} from 'app/requests/ContractBasis/LaneFees.requests'
import {
    TableResponse,
} from 'app/types/request.types'

export default function useLaneFeeFilterRequestAwardReject({
    filters,
}: {
    filters: Record<'aQuoteId', number> | Record<'cQuoteId', number>,
}) {
    return useRequestTable<TableResponse<LaneFeeAwardRejectFilterRequestResponse[]>>({
        key: RequestKeys.laneFeesFilterRequestAwardReject,
        params: {
            data: {
                filters,
            },
        },
        config: requests.laneFeesFilterRequestAwardReject,
        keepPreviousData: true,
        enabled: !isEmpty(filters),
    })
}
